module.exports = __webpack_public_path__ + "static/media/YF84_2.f750402b.jpg";